// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__h1jwr","inputWrap":"CustomTip_inputWrap__3nTRH"};